
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 135.467 52.917"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"transparent","fill-rule":"evenodd","d":"M135.467 52.917H0V0h135.467z"}}),_c('path',{attrs:{"d":"M.126 52.917H135.42L.132.31z","fill":"#fff","fill-opacity":".04"}}),_c('path',{attrs:{"d":"M.126 52.917H92.73L.13.31z","fill":"#ccc","fill-opacity":".12"}})])
          )
        }
      }
    